import type { SponsorRingStyle } from "./types";

/**
 * Default sponsor ring styles per tier.
 * Shared between merge logic (server-safe) and generate-dynamic-marker (browser).
 */
export const DEFAULT_SPONSOR_RING_STYLES: Record<"gold" | "silver" | "bronze", SponsorRingStyle> = {
  gold: { color: "#FFD700", strokeWidth: 3, glowBlur: 2, glowOpacity: 0.5, radiusRatio: 1.2 },
  silver: { color: "#A8A9AD", strokeWidth: 2.5, glowBlur: 1.5, glowOpacity: 0.4, radiusRatio: 1.2 },
  bronze: { color: "#CD7F32", strokeWidth: 2, glowBlur: 1, glowOpacity: 0.3, radiusRatio: 1.2 },
};

/** Legacy tier name → color mapping for backward compat with old sponsorTier enum */
export const LEGACY_TIER_COLORS: Record<string, { color: string; position: number }> = {
  gold: { color: "#FFD700", position: 1 },
  silver: { color: "#A8A9AD", position: 2 },
  bronze: { color: "#CD7F32", position: 3 },
};

/** Size scaling and z-boost per sponsor position (1 = most prominent) */
export const SPONSOR_POSITION_CONFIG = {
  1: { sizeScale: 1.25, zBoost: 50000 },
  2: { sizeScale: 1.15, zBoost: 40000 },
  3: { sizeScale: 1.08, zBoost: 30000 },
} as const;

/**
 * Create a SponsorRingStyle from a dynamic tier color + position.
 * Position 1 (highest sortOrder): 3px stroke + strong glow
 * Position 2: 2.5px stroke + medium glow
 * Position 3+: 2px stroke + subtle glow
 */
export function getRingStyleForPosition(position: number, color: string): SponsorRingStyle {
  if (position <= 1) {
    return { color, strokeWidth: 3, glowBlur: 2, glowOpacity: 0.5, radiusRatio: 1.2 };
  }
  if (position === 2) {
    return { color, strokeWidth: 2.5, glowBlur: 1.5, glowOpacity: 0.4, radiusRatio: 1.2 };
  }
  return { color, strokeWidth: 2, glowBlur: 1, glowOpacity: 0.3, radiusRatio: 1.2 };
}
